import React, { useContext, useMemo } from 'react';
import { Button, useTheme } from '@material-ui/core';
import { useStyles } from './styles';
import { IQuestionnaireRequestData } from 'pages/formsCreate/types';
import { InjectedRouter } from 'react-router';
import { AuthContext } from 'contexts/AuthContext';

type Props = {
  onClose?: () => void;
  onSave?: () => void;
  router?: InjectedRouter;
  enableEdit?: boolean;
  data: Omit<IQuestionnaireRequestData, 'supplierList' | 'inSketch' | 'id'> & { id?: string };
};

export const PreviewFooter = ({ data, onClose, onSave, router, enableEdit = false }: Props) => {
  const theme = useTheme();
  const { previewFooter } = useStyles(theme);

  const {
    user: { isVisaoTok }
  } = useContext(AuthContext);

  const handleEditRedirect = () => {
    if (router && data.id) {
      router.push(`formularios/editar/${data.id}`);
    }
  };

  const handleAnswerForm = () => {
    if (router && data.id) {
      router.push(`formularios/responder/${data.id}`);
    }
  };

  const isAnswerButtonDisabled = useMemo(() => {
    return (
      isVisaoTok ||
      data.inCanceled === 'S' ||
      data.inDraft === 'S' ||
      data.inInactive === 'S' ||
      data.inPublished === 'N'
    );
  }, [data, isVisaoTok]);

  return (
    <div className={previewFooter}>
      <Button onClick={onClose} variant="contained" color="primary">
        Fechar visualização do formulário
      </Button>
      {enableEdit && (
        <Button onClick={handleEditRedirect} variant="outlined" color="primary">
          Editar Formulário
        </Button>
      )}
      {onSave && (
        <Button onClick={onSave} variant="outlined" color="primary">
          Salvar Rascunho
        </Button>
      )}
      {!isAnswerButtonDisabled && (
        <Button onClick={handleAnswerForm} variant="outlined" color="primary">
          {data.answered ? 'Editar Respostas' : 'Responder'}
        </Button>
      )}
    </div>
  );
};
